import React, { useRef, useEffect } from "react";
import "jodit/es5/jodit.min.css";
import { Jodit } from "jodit-react";

const EmailSignatureEditor = ({ value, onChange, keywords }) => {
  const editorRef = useRef(null);
  const joditInstance = useRef(null);

  React.useEffect(() => {
    const config = {
      limitChars: 10000,
      limitHTML: true,
      zIndex: 0,
      readonly: false,
      activeButtonsInReadOnly: ['source', 'fullsize', 'print', 'about', 'dots'],
      toolbarButtonSize: 'middle',
      theme: 'default',
      saveModeInCookie: false,
      spellcheck: true,
      editorCssClass: false,
      triggerChangeEvent: true,
      hidePoweredByJodit: true,
      width: 'auto',
      height: '400',
      direction: '',
      language: 'es',
      debugLanguage: false,
      i18n: 'en',
      tabIndex: -1,
      toolbar: true,
      enter: "P",
      defaultMode: Jodit.MODE_WYSIWYG,
      useSplitMode: false,
      colors: {
        greyscale: ['#000000', '#434343', '#666666', '#999999', '#B7B7B7', '#CCCCCC', '#D9D9D9', '#EFEFEF', '#F3F3F3', '#FFFFFF'],
        palette: ['#980000', '#FF0000', '#FF9900', '#FFFF00', '#00F0F0', '#00FFFF', '#4A86E8', '#0000FF', '#9900FF', '#FF00FF'],
        full: [
          '#E6B8AF', '#F4CCCC', '#FCE5CD', '#FFF2CC', '#D9EAD3', '#D0E0E3', '#C9DAF8', '#CFE2F3', '#D9D2E9', '#EAD1DC',
          '#DD7E6B', '#EA9999', '#F9CB9C', '#FFE599', '#B6D7A8', '#A2C4C9', '#A4C2F4', '#9FC5E8', '#B4A7D6', '#D5A6BD',
          '#CC4125', '#E06666', '#F6B26B', '#FFD966', '#93C47D', '#76A5AF', '#6D9EEB', '#6FA8DC', '#8E7CC3', '#C27BA0',
          '#A61C00', '#CC0000', '#E69138', '#F1C232', '#6AA84F', '#45818E', '#3C78D8', '#3D85C6', '#674EA7', '#A64D79',
          '#85200C', '#990000', '#B45F06', '#BF9000', '#38761D', '#134F5C', '#1155CC', '#0B5394', '#351C75', '#733554',
          '#5B0F00', '#660000', '#783F04', '#7F6000', '#274E13', '#0C343D', '#1C4587', '#073763', '#20124D', '#4C1130'
        ]
      },
      colorPickerDefaultTab: 'background',
      imageDefaultWidth: 300,
      removeButtons: [],
      disablePlugins: [],
      sizeLG: 900,
      sizeMD: 700,
      sizeSM: 400,
      buttons: [
        'source', '|',
        'bold',
        'strikethrough',
        'underline',
        'italic', '|',
        'ul',
        'ol', '|',
        'outdent', 'indent', '|',
        'font',
        'fontsize',
        'brush',
        'paragraph', '|',
        'image',
        'video',
        'table',
        'link', '|',
        'align', 'undo', 'redo', '|',
        'hr',
        'eraser',
        'copyformat', '|',
        'print',
        {
          name: "insertKeyword",
          iconURL: "https://cdn-icons-png.flaticon.com/512/1250/1250615.png",
          tooltip: "Insert Keyword",
          list: Array.isArray(keywords) && keywords.length > 0
          ? keywords.map(k => k.name)
          : [{
              name: "No keywords available",
              icon: "https://path/to/no-keyword-icon.png",
            }],
          exec(editor, _, { control }) {
            let value = control.args && control.args[0];
            editor.s.insertHTML(`{{${value}}}`);
          }
        },
      ],
      buttonsXS: [
        'bold',
        'image', '|',
        'brush',
        'paragraph', '|',
        'align', '|',
        'undo', 'redo', '|',
        'eraser',
        'dots'
      ],
      textIcons: false,
      selectionCellStyle: 'border: 1px double #1e88e5 !important;',
      useExtraClassesOptions: true,
      table: {
        data: {
          classList: {
            'table table-bordered': 'Bootstrap Bordered',
            'table table-striped': 'Bootstrap Striped',
            'table table-dark': 'Bootstrap Dark'
          }
        }
      },
      toolbarAdaptive: false,
      addNewLine: false,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      extraButtons: [
        
      ],
      events: {
        blur: () => {
          if (joditInstance.current) {
            onChange(joditInstance.current.value);
          }
        },
        afterInit: (editorInstance) => {
          const wysiwygElement = editorInstance.container.getElementsByClassName('jodit-wysiwyg')

          if (wysiwygElement?.[0]) {
            wysiwygElement[0].setAttribute('data-testid', 'jodit-wysiwyg');
          }
        },
      },
    };
    joditInstance.current = new Jodit(editorRef.current, config);
    joditInstance.current.value = value;

    return () => {
      if (joditInstance.current) {
        joditInstance.current.destruct();
        joditInstance.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange]);

  useEffect(() => {

    if (joditInstance.current && joditInstance.current.value !== value) {
      joditInstance.current.value = value;
    }
  }, [value]);

  return (
    <div ref={editorRef} style={{ marginRadius: '4px' }} />
  );
};

export default EmailSignatureEditor;
